import { useContext } from 'react';

import { ModalContext, ModalContextValue } from '../contexts';

export const useModal = (): ModalContextValue => {
  return useContext(ModalContext)!;
};
